import { Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fade, FormControlLabel, TextField } from "@material-ui/core";
import React, { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { IConvectionSection } from "../../interfaces/IConvectionSection";
import { RootState } from "../../reducers/rootReducer";
import { checkConvectionsectionName } from "../../services/convectionsectionServices";
import { addConvectionSection, updateConvectionSectionSignature } from "../../slices/convectionSectionSlice";
import FurnaceSelector from "../common/FurnaceSelector";
import { v4 as uuidv4 } from 'uuid';
import { AuthContextProps, withAuth } from "react-oidc-context";
import { getToken } from "../../utilities/helperFunctions";

interface ICloneConvectionSectionProps {
    convectionsection: IConvectionSection;
}

interface OIDCAuth {
    auth?: AuthContextProps
}

const mapStateToProps = (state: RootState) => {
    return {
        currentConvectionSectionId: state.convectionsection.current_convectionsection_id,
        convectionsections: state.convectionsection.convectionsections,
        current_furnace_id: state.furnace.current_furnace_id,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addConvectionSection: (newConvectionSection: IConvectionSection) => dispatch(addConvectionSection(newConvectionSection)),
        updateSignature: (convectionSection_id: string) => dispatch(updateConvectionSectionSignature({ convectionSection_id })),
    };
};
const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type ICloneConvectionSectionReduxProps = PropsFromRedux & ICloneConvectionSectionProps & OIDCAuth;

type ICloneConvectionSectionState = {
    showDialog: boolean;
    name: string;
    is_public: boolean;
    isNameAvailable: boolean;
    nameErrorMessage: string;
    showLoading: boolean;
}
class CloneConvectionSection extends Component<ICloneConvectionSectionReduxProps, ICloneConvectionSectionState>{

    constructor(props) {
        super(props);

        this.state = {
            showDialog: false,
            name: this.props.convectionsection.name,
            is_public: this.props.convectionsection.is_public ? this.props.convectionsection.is_public : false,
            isNameAvailable: false,
            nameErrorMessage: "",
            showLoading: false,
        }
    }

    toggleShowDialog() {
        let getName = this.props.convectionsection.is_public === true ? this.props.convectionsection.name.replace('(PUBLIC)', '') : this.props.convectionsection.name;
        this.setState({
            showDialog: !this.state.showDialog,
            name: getName + "-COPY",
            is_public: this.props.convectionsection.is_public ? this.props.convectionsection.is_public : false,
            isNameAvailable: false,
            nameErrorMessage: ""
        })
    }

    handleNameInput(event) {
        this.setState({
            name: event.target.value.toUpperCase()
        })
    }

    addNewConvectionSection = async () => {
        if (!!this.state.name?.trim()) {

            let setName = this.state.is_public === true ? this.state.name.trim() + "(PUBLIC)" : this.state.name.trim();
            let newConvectionSection: IConvectionSection = {
                ...this.props.convectionsection,
                id: uuidv4(),
                name: setName,
                furnace_id: this.props.current_furnace_id,
                asset_name: this.props.convectionsection.asset_name,
                components: this.props.convectionsection.components,
                signature: this.props.convectionsection.signature,
                is_public: this.state.is_public,
                is_display_leave_popup: true,
                is_saved: false
            }
            try {
                let isNameInRedux = this.props.convectionsections.some(convectionsection => convectionsection.name === newConvectionSection.name);

                if (isNameInRedux) {
                    this.setState({
                        isNameAvailable: true,
                        nameErrorMessage: "Name already exist!",
                        showLoading: false,
                    })
                } else {
                    const accessToken = await getToken(this.props.auth);
                    let isNameAvailable = await checkConvectionsectionName(newConvectionSection, accessToken);
                    if (isNameAvailable.status) {
                        this.setState({
                            isNameAvailable: true,
                            nameErrorMessage: !!isNameAvailable.message ? isNameAvailable.message : "Name already exist!",
                            showLoading: false,
                        })
                    } else {
                        this.props.addConvectionSection(newConvectionSection);
                        this.props.updateSignature(this.props.convectionsection.id);
                        this.toggleShowDialog();
                        this.setState({
                            showLoading: false,
                        })
                    }
                }
            } catch (error) {
                // Api error hendaling 
                this.setState({
                    isNameAvailable: true,
                    showLoading: false,
                    nameErrorMessage: "Oops somthing went to wrong!"
                })
            }
        } else {
            this.setState({
                isNameAvailable: true,
                nameErrorMessage: "Please enter a name!",
                showLoading: false,
            })
        }


    }

    handleChangeIsPublic(event) {
        this.setState({
            is_public: !this.state.is_public
        })
    }

    render() {
        return (
            <div className="control-header element">
                <button
                    className="button"
                    onClick={() => this.toggleShowDialog()}
                    disabled={!this.props.convectionsection.is_saved}
                >
                    Clone
                </button>
                <Dialog open={this.state.showDialog} onClose={() => this.toggleShowDialog()} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Clone convection section</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Clone convection section, please provide the following information:
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Name"
                            type="text"
                            fullWidth
                            defaultValue={this.state.name}
                            value={this.state.name}
                            onChange={(event) => this.handleNameInput(event)}
                            helperText={this.state.nameErrorMessage}
                            error={this.state.isNameAvailable}
                        />
                        <FurnaceSelector disabled={false} furnaceId={this.props.convectionsection.furnace_id} />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.is_public}
                                    onChange={(event) => this.handleChangeIsPublic(event)}
                                    name="isPublic"
                                    value={this.state.is_public}
                                    color="primary"
                                />
                            }
                            label="Is Public?"
                        />
                    </DialogContent>
                    <DialogActions>
                        <button className="button" onClick={() => this.toggleShowDialog()} >
                            Cancel
                        </button>
                        <button className="button" onClick={() => this.addNewConvectionSection()} >
                            Add {this.state.showLoading === true && (
                                <Fade
                                    in={this.state.showLoading}
                                    style={{
                                        transitionDelay: this.state.showLoading ? '800ms' : '0ms',
                                    }}
                                    unmountOnExit
                                >
                                    <CircularProgress size={11} />
                                </Fade>
                            )}
                        </button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

};

export default withAuth(connector(CloneConvectionSection));